export const MAIN_ACTION = {
  CHANGE_STATE: 'MAIN_ACTION_CHANGE_STATE',
  RESET_STATE: 'MAIN_ACTION_RESET_STATE',

  UPDATE_DATA: 'MAIN_ACTION_UPDATE_DATA',

  GET_WALLET: 'MAIN_ACTION_GET_WALLET',
  GET_WALLET_SUCCESS: 'MAIN_ACTION_GET_WALLET_SUCCESS',
  GET_WALLET_FAILED: 'MAIN_ACTION_GET_WALLET_FAILED',

  GET_ACCOUNT_WALLET: 'MAIN_ACTION_GET_ACCOUNT_WALLET',
  GET_ACCOUNT_WALLET_SUCCESS: 'MAIN_ACTION_GET_ACCOUNT_WALLET_SUCCESS',
  GET_ACCOUNT_WALLET_FAILED: 'MAIN_ACTION_GET_ACCOUNT_WALLET_FAILED',

  POST_REFERRAL_CODE: 'MAIN_ACTION_POST_REFERRAL_CODE',
  POST_REFERRAL_CODE_SUCCESS: 'MAIN_ACTION_POST_REFERRAL_CODE_SUCCESS',
  POST_REFERRAL_CODE_FAILED: 'MAIN_ACTION_POST_REFERRAL_CODE_FAILED',

  GET_RECENT_DEPOSITS: 'MAIN_ACTION_GET_RECENT_DEPOSITS',
  GET_RECENT_DEPOSITS_SUCCESS: 'MAIN_ACTION_GET_RECENT_DEPOSITS_SUCCESS',
  GET_RECENT_DEPOSITS_FAILED: 'MAIN_ACTION_GET_RECENT_DEPOSITS_FAILED'
}

export const STAKING_ACTION = {
  CHANGE_STATE: 'MAIN_ACTION_CHANGE_STATE',
  RESET_STATE: 'MAIN_ACTION_RESET_STATE',

  GET_CLAIM_STATUS: 'MAIN_ACTION_GET_CLAIM_STATUS',
  GET_CLAIM_STATUS_SUCCESS: 'MAIN_ACTION_GET_CLAIM_STATUS_SUCCESS',
  GET_CLAIM_STATUS_FAILED: 'MAIN_ACTION_GET_CLAIM_STATUS_FAILED',

  CLAIM_STAKE: 'MAIN_ACTION_CLAIM_STAKE',
  CLAIM_STAKE_SUCCESS: 'MAIN_ACTION_CLAIM_STAKE_SUCCESS',
  CLAIM_STAKE_FAILED: 'MAIN_ACTION_CLAIM_STAKE_FAILED'
}

export const LEADERBOARD_ACTION = {
  CHANGE_STATE: 'LEADERBOARD_ACTION_CHANGE_STATE',
  RESET_STATE: 'LEADERBOARD_ACTION_RESET_STATE',

  GET_DATA: 'LEADERBOARD_ACTION_GET_DATA',
  GET_DATA_SUCCESS: 'LEADERBOARD_ACTION_GET_DATA_SUCCESS',
  GET_DATA_FAILED: 'LEADERBOARD_ACTION_GET_DATA_FAILED'
}
